{
	"title": "Offline",
	"leadAnonymous": "Looks like you don't have internet. Check Wi-Fi or mobile network and try again.",
	"leadAuth": "{name}, please check Wi-Fi. Some data is available from cache.",
	"lastSync": "Last sync",
	"noSync": "No sync info",
	"retry": "Try again",
	"checking": "Checking connection…",
	"openCached": "Open cached",
	"restored": "Connection restored",
	"restoredAuto": "Reload page",
	"continueOnline": "Continue",
	"limits": {
		"works": "Works offline",
		"fails": "Not available",
		"notes": "Read notes",
		"flashcards": "Saved flashcards",
		"recordings": "Lecture recordings log",
		"ai": "AI generation (tutor, notes)",
		"search": "Search across all materials",
		"billing": "Billing"
	},
	"cached": {
		"available": "Available from cache",
		"materials": "{count, plural, one {# material} other {# materials}}",
		"notes": "{count, plural, one {# note} other {# notes}}",
		"flashcards": "{count, plural, one {# flashcard} other {# flashcards}}",
		"tutorChats": "{count, plural, one {# tutor chat} other {# tutor chats}}"
	},
	"banner": {
		"message": "Offline — changes will be saved locally",
		"dismiss": "Close"
	}
}
